import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class HttpProcessInterceptor implements HttpInterceptor {
     constructor(
            private router: Router,
        ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
        .pipe(
            retry(1),
            map((res: any) => {
                return res;
            }),
            catchError((error: HttpErrorResponse) => {
                if(error.error) {
                    if(error.error.Message == 'Authorization has been denied for this request.') {
                        localStorage.removeItem('currentIMEXUser');
                        this.router.navigate(['/login']);
                    }
                    return throwError(error);
                }
            })
        )
    }
}

export const HttpHelper = {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpProcessInterceptor,
    multi: true
};
